import { STORAGE_KEYS } from "./storageKeys";

const API_URL = import.meta.env.VITE_API_URL;

export const get = async (url: string, options?: RequestInit) => {
  const response = await fetch(`${API_URL}${url}`, {
    ...options,
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error("Failed to fetch data");
  }

  const data = await response.json();

  return {
    data,
    response,
  };
};

type PostBody = Record<string, unknown>;
type PutBody = Record<string, unknown>;

export const post = async (
  url: string,
  body: PostBody,
  options?: RequestInit,
) => {
  const response = await fetch(`${API_URL}${url}`, {
    ...options,
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
    body: JSON.stringify(body),
  });

  if (response.status === 401) {
    localStorage.removeItem(STORAGE_KEYS.REACT_QUERY_OFFLINE_CACHE);
    window.location.href = "/login";
    throw new Error("Unauthorized");
  }

  const data = await response.json();

  return {
    data,
    response,
  };
};

export const put = async (
  url: string,
  body: PutBody,
  options?: RequestInit,
) => {
  const response = await fetch(`${API_URL}${url}`, {
    ...options,
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
    body: JSON.stringify(body),
  });

  if (response.status === 401) {
    localStorage.removeItem(STORAGE_KEYS.REACT_QUERY_OFFLINE_CACHE);
    window.location.href = "/login";
    throw new Error("Unauthorized");
  }

  const data = await response.json();

  return {
    data,
    response,
  };
};

export const del = async (url: string, options?: RequestInit) => {
  const response = await fetch(`${API_URL}${url}`, {
    ...options,
    method: "DELETE",
    credentials: "include",
  });

  if (response.status === 401) {
    localStorage.removeItem(STORAGE_KEYS.REACT_QUERY_OFFLINE_CACHE);
    window.location.href = "/login";
    throw new Error("Unauthorized");
  }

  return {
    response,
  };
};
